import React, { memo, useCallback } from 'react'
import { ReactComponent as ChevronLeft } from '../../assets/images/chevron-left.svg'
import {
  PostAppointmentProvider,
  usePostAppointmentContext,
} from '../../context/PostAppointmentContext/PostAppointmentProvider'
import { formatMMDDYYYY, formatTime } from '../../utils/time.utils'
import PostAppointmentRouter from './PostAppoinmentRouter'
import Stepper from './Stepper'
import './styles.scss'

const PostAppointmentNote: React.FC = () => {
  const {
    previousScreen,
    setCurrentScreen,
    updateSelectedNote,
    updateSelectedAppointment,
    currentScreen,
    selectedAppointment,
    selectedNote,
    showNoFollowUp,
    updateShowFollowUp,
    isEditing,
  } = usePostAppointmentContext()

  const handleBack = useCallback(() => {
    // An edit walks its own step list, and stepping off the first one leaves
    // the flow, so it must not fall through to the signed-note branch below.
    if (isEditing) {
      previousScreen()
      return
    }

    if (selectedNote?.status !== 'signed') {
      if (currentScreen === 'orders' && showNoFollowUp) {
        updateShowFollowUp()
        return
      }

      if (currentScreen === 'orders') {
        updateSelectedAppointment(undefined)
      }

      previousScreen()
    } else {
      updateSelectedNote(undefined)
      updateSelectedAppointment(undefined)
      setCurrentScreen('initial')
    }
  }, [
    selectedNote,
    currentScreen,
    showNoFollowUp,
    updateShowFollowUp,
    isEditing,
    previousScreen,
  ])

  return (
    <div className="pt-3 px-4 px-md-5 px-lg-10 post-appointment">
      <div className="d-flex w-100 align-items-center justify-content-between">
        <div className="back">
          {currentScreen !== 'initial' && (
            <div
              className="d-flex align-items-center cursor-pointer mb-2 back"
              onClick={handleBack}
            >
              <ChevronLeft className="nav-icon-small text-primary" />
              <p className="spaced-capital-letters mb-0 text-primary space-8">
                Back
              </p>
            </div>
          )}
        </div>

        <div>
          <p className="h1 mb-2 mt-2 fs-12 text-center title">
            {currentScreen === 'initial'
              ? 'Appointment Notes'
              : selectedAppointment?.type.category}
          </p>
          {currentScreen !== 'initial' && (
            <p className="h1 mb-2 mt-2 fs-12 text-center title">
              {formatMMDDYYYY(new Date(selectedAppointment?.time ?? ''))}{' '}
              {formatTime(new Date(selectedAppointment?.time ?? ''))}
            </p>
          )}
        </div>

        <div className="back-spacer"></div>
      </div>

      <br />
      {currentScreen !== 'initial' &&
        (isEditing || selectedNote?.status !== 'signed') && (
          <div className="d-flex w-100 flex-column align-items-center">
            {isEditing && (
              <p className="editing-banner mb-2">Editing a submitted note</p>
            )}
            <Stepper />
          </div>
        )}
      <br />
      <div>
        <PostAppointmentRouter />
      </div>
    </div>
  )
}

const PostAppointmentPanel = () => {
  return (
    <PostAppointmentProvider>
      <PostAppointmentNote />
    </PostAppointmentProvider>
  )
}

export default memo(PostAppointmentPanel)
